const s = Math.cos, o = Math.sin, c = Math.sqrt, t = Math.PI, n = 2 * t;
export {
  s as cos,
  t as pi,
  o as sin,
  c as sqrt,
  n as tau
};
